/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsReceivedConversationRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.reviews.received.conversation',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsReceivedConversationRoute, {
  overrideRenderTemplate: false,
});
